import styled from 'styled-components';

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;
